import SubscriptionPlansPage from "../../../modules/billing/subscription-plans/SubscriptionPlansPage";

const AddSubscription = () => (
  <SubscriptionPlansPage routeModalMode="create" />
);

export default AddSubscription;
